import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import UnavailableDaysList from './UnavailableDaysList'

export default function UnavailableDays() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/unavailable_days" component={UnavailableDaysList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}